import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FolderTreeNode } from '../../core/models/folder.model';
import { I18nService } from '../../core/services/i18n.service';

@Component({
  selector: 'app-folder-tree',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="tree-root">
      <div class="tree-item root" [class.active]="selectedFolderId === null" (click)="rootSelected.emit()">
        📁 {{ i18n.t('folderTree.root') }}
      </div>

      <ng-container *ngFor="let node of nodes">
        <ng-container *ngTemplateOutlet="treeNodeTemplate; context: { $implicit: node, level: 0 }"></ng-container>
      </ng-container>

      <ng-template #treeNodeTemplate let-node let-level="level">
        <div class="tree-node">
          <div class="tree-item" [class.active]="selectedFolderId === node.id" [style.paddingInlineStart.px]="16 + level * 20">
            <button class="expand-btn" *ngIf="node.children.length > 0" (click)="toggle(node, $event)">
              {{ node.expanded ? '▾' : '▸' }}
            </button>

            <span class="folder-label" (click)="folderSelected.emit(node)">
              📁 {{ node.name }}
            </span>
          </div>

          <div *ngIf="node.expanded">
            <ng-container *ngFor="let child of node.children">
              <ng-container *ngTemplateOutlet="treeNodeTemplate; context: { $implicit: child, level: level + 1 }"></ng-container>
            </ng-container>
          </div>
        </div>
      </ng-template>
    </div>
  `,
  styles: [`
    .tree-root { display: flex; flex-direction: column; gap: 4px; }
    .tree-item { display: flex; align-items: center; gap: 8px; min-height: 40px; border-radius: 10px; cursor: pointer; user-select: none; }
    .tree-item:hover { background: #f3f4f6; }
    .tree-item.active { background: #e5e7eb; font-weight: 600; }
    .expand-btn { border: 0; background: transparent; cursor: pointer; width: 24px; }
    .folder-label { flex: 1; display: inline-block; padding: 8px 0; }
    .root { padding-inline-start: 16px; }
  `]
})
export class FolderTreeComponent {
  readonly i18n = inject(I18nService);
  @Input() nodes: FolderTreeNode[] = [];
  @Input() selectedFolderId: number | null = null;
  @Output() folderSelected = new EventEmitter<FolderTreeNode>();
  @Output() rootSelected = new EventEmitter<void>();

  toggle(node: FolderTreeNode, event: MouseEvent): void {
    event.stopPropagation();
    node.expanded = !node.expanded;
  }
}
